export default {
  SET_LOADING(state) {
    state.isLoading = true;
  },

  UNSET_LOADING(state) {
    state.isLoading = false;
  }
};
